import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { InquiryFormRequestBody, InquiryFormResponse } from "./types";

export class InquiryFormAPI extends BaseAPI<
    InquiryFormRequestBody,
    InquiryFormResponse
> {
    protected route = ApiRoutes.home.inquiry_form;
    protected method = RequestMethod.POST;
}
